import React, { useState } from "react";
import useUser from "../hooks/user/useUser";
import AdminCard from "../components/AdminPage/AdminCard";
import UserManagement from "../components/AdminPage/UserManagement";


const AdminPage = () => {
    const { userState } = useUser();
    const [activeSection, setActiveSection] = useState<string>('dashboard');

    return (
        <div className="tw-min-h-screen tw-bg-base-200">
            <div className="tw-container tw-mx-auto tw-px-4 tw-py-8">
                {/* Header */}
                <div className="tw-text-center tw-mb-8">
                    <h1 className="tw-text-4xl tw-font-bold tw-text-primary tw-mb-2">
                        Panel de Administración
                    </h1>
                    <p className="tw-text-lg tw-text-base-content tw-opacity-70">
                        Bienvenido, {userState.name} - Nivel {userState.level}
                    </p>
                </div>

                {/* Dashboard con las cartas */}
                {activeSection === 'dashboard' && (
                    <div className="tw-flex tw-justify-center tw-max-w-4xl tw-mx-auto">
                        <AdminCard
                            title="Gestión de Usuarios"
                            description="Consultar actividad de usuarios por país y rango de fechas"
                            icon={
                                <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m3 5.197H9m3 0a4 4 0 01-4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            }
                            buttonText="Acceder"
                            onButtonClick={() => setActiveSection('users')}
                        />


                    </div>
                )}

                {/* Panel de Gestión de Usuarios */}
                {activeSection === 'users' && (
                    <div className="tw-max-w-7xl tw-mx-auto">
                        <div className="tw-mb-6">
                            <button 
                                className="tw-btn tw-btn-ghost tw-btn-sm"
                                onClick={() => setActiveSection('dashboard')}
                            >
                                <svg className="tw-w-4 tw-h-4 tw-mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                                Volver al Dashboard
                            </button>
                        </div>
                        <UserManagement />
                    </div>
                )}





            </div>
        </div>
    );
};

export default AdminPage;
